import scrollMonitor from 'scrollmonitor'
import { isEmpty, isUndefined } from './Utils'

export default class ScrollAnimations {
    constructor() {
        this.cacheDom()
        this.initialize()
    }

    cacheDom() {
        this.elements = document.querySelectorAll('[data-animate]')
    }

    initialize() {
        if (!isEmpty(this.elements) && !isUndefined(scrollMonitor.create)) {
            Array.prototype.forEach.call(this.elements, (el, i) => {
                let entered = false
                const watchedItem = scrollMonitor.create(el, (window.innerHeight / 5) * -1)

                if (el.hasAttribute('data-delay')) {
                    el.style.transitionDelay = `${el.getAttribute('data-delay')}ms`
                }

                watchedItem.enterViewport(() => {
                    if (!entered) {
                        entered = true
                        el.classList.add('animate')
                    }
                })
            })
        }
    }
}
